import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { FormUtil } from 'src/app/utils/form.util';
import { WorkflowStepUtils } from 'src/app/utils/workflow-step.utils';
import { Globals } from '../global/globals';
import { IWorkflowStepBase } from '../models/workflow-step/workflow-step-base.model';
import { WorkflowStep } from '../enums/WorkflowStep';

@Injectable({
  providedIn: 'root'
})
export class WorkflowInstanceStepGlomaxService {

  private readonly baseUri: string;

  constructor(private http: HttpClient,
              private globals: Globals) {
    this.baseUri = this.globals.backendUri + '/workflow-instance-steps/glomax';
  }

  manuallyAddFileByWorkflowInstanceId(workflowInstanceId: number, workflowStep: WorkflowStep, fileList: FileList): Observable<IWorkflowStepBase> {
    const formData = FormUtil.createFormDataFromFirstFile(fileList);
    return this.http.post<IWorkflowStepBase>(`${ this.baseUri }/upload-by-instance/${ workflowInstanceId }?workflowStep=${ workflowStep }`, formData)
      .pipe(map(WorkflowStepUtils.initWorkflowStepFromData));
  }

}
